<template>
  <div>
    <CommonSection />
    <div class="container-fluid"></div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
export default {
  components: {
    CommonSection
  }
};
</script>
<style></style>
